import React, { FC, useState } from 'react';
import { Box, Tabs, Tab, Button } from '@mui/material';
import { Add as AddIcon, Assessment as AssessmentIcon } from '@mui/icons-material';
import CostCategoryDataGrid from '../../components/CostCentre/CostCategoryDataGrid';
import CostCentreDataGrid from '../../components/CostCentre/CostCentreDataGrid';
import CostCentreReportPage from '../Reports/CostCentreReportPage';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: FC<TabPanelProps> = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`cost-centre-tabpanel-${index}`}
      aria-labelledby={`cost-centre-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

const CostCentreManagement: FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const [openCostCentreForm, setOpenCostCentreForm] = useState(false);
  const [openCategoryForm, setOpenCategoryForm] = useState(false);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleAddClick = () => {
    if (tabValue === 1) {
      setOpenCostCentreForm(true);
    } else if (tabValue === 2) {
      setOpenCategoryForm(true);
    }
    // No action for Report tab (tabValue === 0)
  };

  return (
    <>
      {/* Separate Tab Bar Container - Break out of parent padding */}
      <Box sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        borderBottom: 1,
        borderColor: 'divider',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 'calc(100% + 48px)',
        marginLeft: '-24px',
        marginRight: '-24px',
        paddingLeft: '24px',
        paddingRight: '24px'
      }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="Cost Centre Tabs" sx={{ minHeight: 48 }}>
          <Tab label="Cost Centre Report" icon={<AssessmentIcon />} iconPosition="start" sx={{ textTransform: 'none', fontWeight: 600, minHeight: 48, py: 1 }} />
          <Tab label="Cost Centres" sx={{ textTransform: 'none', fontWeight: 600, minHeight: 48, py: 1 }} />
          <Tab label="Cost Categories" sx={{ textTransform: 'none', fontWeight: 600, minHeight: 48, py: 1 }} />
        </Tabs>
        {tabValue !== 0 && (
          <Button
            startIcon={<AddIcon />}
            onClick={handleAddClick}
            variant="contained"
            size="small"
            sx={{ height: '36px', textTransform: 'none' }}
          >
            {tabValue === 1 ? 'Add Cost Centre' : 'Add Category'}
          </Button>
        )}
      </Box>

      {/* Content Container - Separate from Tab Bar */}
      <Box sx={{ mt: 2 }}>
        <TabPanel value={tabValue} index={0}>
          <CostCentreReportPage />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <CostCentreDataGrid
            openFormExternal={openCostCentreForm}
            onCloseFormExternal={() => setOpenCostCentreForm(false)}
          />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <CostCategoryDataGrid
            openFormExternal={openCategoryForm}
            onCloseFormExternal={() => setOpenCategoryForm(false)}
          />
        </TabPanel>
      </Box>
    </>
  );
};

export default CostCentreManagement;
